import React, { FC, useEffect, useState } from 'react'
import { BorderedPageLayout } from '../../../pages/BorderedPageLayout'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { ModalContentProps } from '../../Modal'
import { handleTemplateSheetAnalysisInfoModal } from '../../../features/modals/modalsSlice'
import useTheme from '../../../hooks/useAppColor'
import { AnalysisApi } from '../../../types/entities/analysis.types'
import { useNavigate } from 'react-router-dom'
import { CreateSheet, SearchIcon, TrashIcon } from '../../../icons'
import { DelTemplate, getAllTemplates} from '../../../features/templates/templatesSlice'
import { useDeferred } from '../../../hooks/useDeffered'

export const TemplateSheetInfoModalContent: FC<ModalContentProps> = ({ handleModal, level }) => {
    const dispatch = useAppDispatch()
    const getTheme = useTheme()
    const navigate = useNavigate()
    const user_id = useAppSelector(state => state.profile.profile_id)
    const templates = useAppSelector(state => state.products.templates)
    const agent_id = useAppSelector(state => state.profile.profile_id)
    const [filteredTemplates, setFilteredTemplates] = useState(templates);

    const handleTemplateInfo = (data: any) => dispatch(handleTemplateSheetAnalysisInfoModal(data))

    const [searchVal, setSearchVal] = useState("")
    const defferedSearchVal = useDeferred(searchVal, 500)

    useEffect(() => {
        const lowerCaseSearch = defferedSearchVal.toLowerCase();
        const filtered = templates.filter((item: any) =>
            item.name.toLowerCase().includes(lowerCaseSearch)
        );
        setFilteredTemplates(filtered);
    }, [defferedSearchVal])

    useEffect(() => {
        setFilteredTemplates(templates);
    }, [templates]);

    return (
        <BorderedPageLayout
            modal={{ level: level || 1 }}
            handleModal={handleModal}
            contentClassName='f-column gap-40'>
            <div className="d-f jc-between">
                <div onClick={handleModal} className="textButton fz-l">Закрыть</div>
                <p className={`fw-5 fz-l fw-6 ${getTheme("c-dark", "c-lg")}`}>Стандартные шаблоны</p>
                <div className='f-025'></div>
            </div>
             <div className={`d-f pd-10 al-center gap-5 search-block w-100p ${getTheme("", "app-bg-dark svg-gray-filled")}`}>
                                        <SearchIcon />
                                        <input value={searchVal} onChange={e => setSearchVal(e.target.value)} className={`w-100p fz-m ${getTheme("", "c-white")}`} type="text" placeholder='Найти шаблон по названию' />
                                    </div>
            <div className="f-1 p-rel">
                <div className="list p-rel w-100p f-column scrollableItemsList gap-20">
                    {
                        filteredTemplates.map((item: any, index: any) => {
                            return <div className={`d-f jc-between al-center pd-10-0 border-bottom`} key={index}>
                                <h2 key={item.name} className={`fz-l ${getTheme("", "c-white")}`} onClick={() => handleTemplateInfo({name: item.name, list: item.list})}>
                                {item.name}
                                </h2>
                            </div>
                        })
                    }
                </div>      
            </div>            
        </BorderedPageLayout>
    )
}
